import o from "./index.es407.js";
import r from "./index.es408.js";
import t from "./index.es409.js";
const e = {
  isBrowser: !0,
  classes: {
    URLSearchParams: o,
    FormData: r,
    Blob: t
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
export {
  e as default
};
//# sourceMappingURL=index.es334.js.map
